import { WitaConnector } from '@/services/repository/connector'
import { querySerializer } from '@/utils/helpers/URLs'

import { Repo } from './CallProduct.d'

const ROOT_URL = '/entity/call-product'

export const CallProduct_Repository = {
  Search: async (params: Repo.CallProduct.Search.Params) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<Repo.CallProduct.Search.Response>(url)
  },

  Create: async (params: Repo.CallProduct.Create.Params) => {
    const url = ROOT_URL
    return await WitaConnector.post<Repo.CallProduct.Create.Response>(
      url,
      params,
    )
  },

  Add: async ({ id }: Repo.CallProduct.Add.Params) => {
    const url = ROOT_URL + `/${id}/add`
    return await WitaConnector.put<Repo.CallProduct.Add.Response>(url, null)
  },

  Remove: async ({ id }: Repo.CallProduct.Remove.Params) => {
    const url = ROOT_URL + `/${id}/remove`
    return await WitaConnector.put<Repo.CallProduct.Remove.Response>(url, null)
  },
}
